import { render, staticRenderFns } from "./BusinessDashboard.vue?vue&type=template&id=7922ee14&"
import script from "./BusinessDashboard.vue?vue&type=script&lang=ts&"
export * from "./BusinessDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports